import { Component, OnInit, Inject, Input, Output, EventEmitter} from '@angular/core';
import { ViewsService } from "@app/services/views.service";
import { TinyMCEOptions } from '@app/shared/tinymce_options';
import { CourseService } from '@scaffold/services/course.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '@scaffold/services/items.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
@Component({
  selector: 'app-add-data-inline',
  templateUrl: './add-data-inline.component.html',
  styleUrls: ['./add-data-inline.component.scss']
})
export class AddDataInlineComponent implements OnInit {
  path = '';
  view = [];
  create = {
    id: null,
    type:null,
    data: {}
  };
  @Input() data;
  @Input() item;
  @Output() updated = new EventEmitter<string>();
  create_data: item_data = {
  };
  created = false
  activeTab = 0;
  parent;
  constructor(public viewService: ViewsService, public editor: TinyMCEOptions, private courseService: CourseService, private route: ActivatedRoute, private itemsService: ItemsService, private viewUpdate: ViewUpdateService) { }

  ngOnInit() {
  //  console.log(this.data)
    //pass is some predefined values in data.data as an object  {"key":value}
    /*if (this.data.data) {
      Object.keys(this.data.data).forEach(key => {
        this.setValue(key, this.data.data[key])
      });
      this.triggerUpdate('editor change trigger');
    }*/
   // console.log(this.create_data);
    if (this.data.parent) {
      this.parent = this.data.parent
      this.path = this.parent.type + '/' + this.parent.id
    } else {
      this.path = 'courses/' + this.courseService.id
      this.parent = { id: this.courseService.id, type: "courses" }
    }    
    this.path = "";
    if (this.data.parent && this.data.parent.type && this.data.parent.id) {
      this.parent = this.data.parent
      this.path += this.data.parent.type + '/' + this.data.parent.id + "/";
    } else if (this.courseService.id) {
      this.path += 'courses/' + this.courseService.id + "/";
      this.parent = { id: this.courseService.id, type: "courses" }
    }
    this.path += this.data.type.name; 
    var createurl = this.data.type.name + "/" + (this.item.create_mode || 'create');
    this.courseService.get(createurl).subscribe(co => {
      if (co && co.push) {
        this.create.id = co[0].id;
        this.create.data = co[0].data;
      } else {
        if (co) {
          this.create.id = co.id;
          this.create.data = co.data;
        }
      }
      this.create_data = this.itemsService.getData(this.create)
      //pass is some predefined values in data.data as an object  {"key":value}
      if (this.data.data) {
        Object.keys(this.data.data).forEach(key => {
          this.itemsService.updateValue(key, this.data.data[key], this.create)
        });
        //this.triggerUpdate('editor change trigger');
      }
      console.log(this.create_data);
      this.updated.emit("load create");
      this.triggerUpdate("Loaded create view")
    });
  
  }

  createData(type) {
    if (!this.created) {
      this.created = true
      delete this.create_data.data_input_error;
      var parents = {};
      delete this.create_data.child;
      var data = {
        type: type,
        data: this.create_data
      }
      console.log(this.path);
      console.log(this.create_data)
      this.itemsService.createData(this.path, data).subscribe(d => {
        if (this.parent) {
          this.viewUpdate.triggerListChange({ "list_type": 'list', "type": d.type, "added": d.id, parent_type : this.parent.type , parent_id : this.parent.id })
        }
      });
    }
  }

  setValue(setting, value) {
    this.create_data[setting] = value;
    this.itemsService.updateValue(setting, value, this.create);
    //this.forceRequiredCheck(setting);
    
  }

  forceRequiredCheck(setting) {
    console.log(this.create_data)
    if (this.create_data.data_input_error && this.create_data.data_input_error[setting] == 'Required') {
      delete this.create_data.data_input_error[setting];
      var count = 0;
      var keys = Object.keys(this.create_data.data_input_error)
      console.log(keys);
      keys.forEach(key => {
        if (this.create_data.data_input_error.hasOwnProperty(key)) {
          count++;
        }
      })
      console.log(count)
      if (count == 0) {
        delete this.create_data.data_input_error;
      }
    }
  }

  hasErrors() {
    return this.itemsService.disableSave(this.create.type)
  }

  triggerUpdate(e?) {
    // console.log(e);
    try {
      this.viewUpdate.triggerChangePropagation(e);
    } catch (e) {
      //  console.log(e)
    }
  }
}


class item_data {
  child?;
  position?;
  content_id?;
  type?;
  reference_id?;
  data_input_error?;
}
